import React from 'react';

interface SheetMessageProps {
  kind: 'ok' | 'err' | 'info';
  children: React.ReactNode;
}

/** Glass note for request-level success / error feedback inside sheet views. */
const SheetMessage: React.FC<SheetMessageProps> = ({ kind, children }) => (
  <div
    className={`tend-note${kind === 'ok' ? ' tend-note--ok' : ''}${
      kind === 'err' ? ' tend-note--err' : ''
    }`}
    role={kind === 'err' ? 'alert' : 'status'}
  >
    {children}
  </div>
);

export default SheetMessage;
